module.exports = __webpack_public_path__ + "img/thumb_19.6c8ba34f.jpg";